/*
 * @Description: 客户中心路由模块
 * @Author: mdb
 * @Date: 2022-05-31 17:36:20
 * @LastEditTime: 2022-09-22 13:55:43
 * @LastEditors: cxh
 */
import Layout from '@/layout/index.vue'
const routerItem = {
  path: '/customer',
  component: Layout,
  children: [
    {
      path: 'customerManage',
      name: 'DcCosCustomerManage',
      meta: { title: '客户管理' },
      component: require('@/views/customer/customerManage/index.vue').default
    },
    {
      path: 'customerAggregation',
      name: 'DcCosCustomerAggregation',
      meta: { title: '客户明细' },
      component: require('@/views/customer/customerAggregation/index.vue').default
    },
    {
      path: 'customerAggregation/view',
      name: 'DcCosCustomerAggregationView',
      meta: { title: '客户明细' },
      component: require('@/views/customer/customerAggregation/view/index.vue').default
    }
  ]
}
export default routerItem
